<div class="row height-100 m-0">
  <div class="col-12 col-sm-5 p-0">
    <div class="row height-100 m-0">
      <div class="col-12 p-0" [ngStyle]="{'height': data.records ? '50%' : '100%'}">
        <lib-prod-header [title]="'Hub'">
          <lib-prod-form [fields]="fields"
                         [data]="dialogData.data"
                         (onSubmitEvent)="submit($event)"></lib-prod-form>
        </lib-prod-header>
      </div>
      <div class="col-12 p-0" style="height: 50%" *ngIf="data.records">
        <app-heartbeat-grid [dialogData]="dialogData"></app-heartbeat-grid>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-7 p-0">
    <lib-prod-header [title]="'Map'">
      <lib-prod-map
        [mapName]="mapName"
        [isMarkersDraggable]="isFieldsEditable"
        [markers$]="markers$"
        [mapDefaultZoom]="17"
        [isMarkersHasCircles]="true"
        [isCirclesPulse]="true"
        (prodMapEvents$)="prodMapEvents($event)"></lib-prod-map>
    </lib-prod-header>
  </div>
</div>
